import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, ShoppingBag, Phone } from "lucide-react";
import { NAV_ITEMS, LINKS } from "../mock/data";
import BrandLogo from "./BrandLogo";

export default function Footer() {
  return (
    <footer className="bg-black pt-16 pb-8 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <BrandLogo size={44} />
            <p className="mt-5 text-white/50 max-w-md leading-relaxed">
              The science of lighting. Race-proven LED lighting for automotive and motorcycle adventures, now available across India.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:border-baja-red hover:bg-baja-red text-white transition-colors">
                <Instagram size={18} />
              </a>
              <a href={LINKS.shop} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:border-baja-red hover:bg-baja-red text-white transition-colors">
                <ShoppingBag size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-cond uppercase tracking-widest text-sm text-white/40 mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {NAV_ITEMS.map((n) => (
                <li key={n.label}>
                  <Link to={n.to} className="text-white/70 hover:text-baja-red transition-colors font-cond text-lg">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-cond uppercase tracking-widest text-sm text-white/40 mb-4">Get In Touch</h4>
            <a href={LINKS.shop} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-baja-red hover:bg-[#ff1a44] text-white font-cond uppercase tracking-wider text-sm px-5 py-2.5 transition-colors">
              <ShoppingBag size={16} /> Shop Now
            </a>
            <div className="flex items-start gap-2 mt-6 text-white/50 text-sm leading-relaxed">
              <MapPin size={18} className="baja-red shrink-0 mt-0.5" />
              <span>
                <span className="text-white/80 font-600">Plusgrow Merchantry Pvt Ltd</span>
                <br />T31A MIDC, Hingna Rd,<br />Nagpur 16, India
              </span>
            </div>
            <a href="tel:+919373788088" className="flex items-center gap-2 mt-3 text-white/50 hover:text-baja-red transition-colors text-sm">
              <Phone size={18} className="baja-red shrink-0" />
              +91 93737 88088
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center md:text-left leading-relaxed max-w-3xl">
            Video content via the official Baja Designs YouTube channel. Vehicle photography via Unsplash &amp; Pexels contributors, used for demonstration only.
          </p>
          <p className="text-white/40 text-xs whitespace-nowrap">© {new Date().getFullYear()} Baja Designs India</p>
        </div>
      </div>
    </footer>
  );
}
